export const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia & Herzegovina",
    "Botswana",
    "Brazil",
    "British Virgin Is.",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burma",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Cayman Islands",
    "Central African Rep.",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo",
    "Cook Islands",
    "Costa Rica",
    "Cote d'Ivoire",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "Gabon",
    "Gambia",
    "Gaza Strip",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macau",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia Fed. St.",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "Netherlands Antilles",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "N. Mariana Islands",
    "North Korea ",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Reunion",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Helena",
    "Saint Kitts & Nevis",
    "Saint Lucia",
    "St Pierre & Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome & Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Korea ",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad & Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks & Caicos Is",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela",
    "Vietnam",
    "Virgin Islands",
    "Wallis and Futuna",
    "West Bank",
    "Western Sahara",
    "Yemen",
    "Zambia",
    "Zimbabwe",
]
export const Months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
]
const year = (new Date()).getFullYear();
export const years = Array.from(new Array(100),( val, index) => year - index);
export const industries = ["Mining, quarrying, and oil and gas extraction",
 "Oil and gas extraction",
 "Mining",
 "Support activities for mining and oil and gas extraction",
 "Utilities",
 "Electric power generation, transmission and distribution",
 "Natural gas distribution",
 "Water, sewage and other systems",
 "Construction",
 "Manufacturing",
 "Food manufacturing and beverage manufacturing",
 "Food manufacturing",
 "Animal food manufacturing",
 "Fruit and vegetable preserving and specialty food manufacturing",
 "Dairy product manufacturing",
 "Meat product manufacturing",
 "Seafood product preparation and packaging",
 "Bakery and tortillas manufacturing",
 "Beverage and tobacco product manufacturing",
 "Beverage manufacturing",
 "Tobacco manufacturing",
 "Textile mills and textile product mills",
 "Textile mills",
 "Textile product mills",
 "Clothing manufacturing",
 "Cut and sew clothing manufacturing",
 "Leather and allied product manufacturing",
 "Wood product manufacturing",
 "Sawmills and wood preserving",
 "Veneer,plywood and engineered wood product manufacturing",
 "Other wood product manufacturing",
 "Paper manufacturing",
 "Pulp,paper,and paperboard mills",
 "Converted paper product manufacturing",
 "Printing and related support activities",
 "Petroleum and coal product manufacturing",
 "Chemical manufacturing",
 "Chemical manufacturing except pharmaceutical manufacturing",
 "Basic chemical manufacturing",
 "Resin synthetic rubber and artificial synthetic fibres and filaments manufacturing",
 "Pharmaceutical manufacturing",
 "Paint,coating and adhesive manufacturing",
 "Pesticide,fertilizer and other agricultural chemical manufacturing",
 "soap,cleaning compound and toilet preparation manufacturing",
 "and other chemical product manufacturing",
 "Plastics and rubber products manufacturing",
 "Plastic product manufacturing except Motor vehicle plastic parts manufacturing",
 "Motor vehicle plastic parts manufacturing",
 "Rubber product manufacturing",
 "Non-metallic mineral product manufacturing",
 "Primary metal manufacturing",
 "Iron and steel mills and ferro-alloy manufacturing",
 "steel product manufacturing from purchased steel",
 "non-ferrous metal (except aluminium) production and process",
 "Alumina and aluminum production and processing",
 "Ferrous metal foundries",
 "Non-ferrous metal foundries",
 "Fabricated metal product manufacturing",
 "Forging and stamping",
 "cutlery and hand tool manufacturing",
 "hardware manufacturing",
 "spring and wire product manufacturing",
 "other fabricated metal product manufacturing",
 "Architectural and structural metals manufacturing",
 "Boiler,tank and shipping container manufacturing",
 "Machine shops,turned product and screw,nut and bolt manufacturing",
 "Coating,engraving,heat treatment and allied activities",
 "Machinery manufacturing",
 "Machinery manufacturing except mining and oil and gas field machinery manufacturing",
 "sawmill and woodworking machinery manufacturing",
 "rubber and plastics industry machinery manufacturing",
 "ventilation,heating, air-conditioning, and commercial refrigeration",
 "Mining and oil and gas field machinery manufacturing",
 "Sawmill and woodworking machinery manufacturing",
 "Rubber and plastics industry machinery manufacturing",
 "Ventilation,heating, air-conditioning, and commercial refrigeration equipment manufacturing",
 "Metalworking machinery manufacturing",
 "Computer and electronic product manufacturing",
 "Computers and peripheral equipment manufacturing",
 "Communications equipment manufacturing",
 "Telephone apparatus manufacturing",
 "Radio and television broadcasting and wireless communications equipment",
 "Semiconductor and other electronic components manufacturing",
 "Navigational and guidance instruments manufacturing",
 "Electrical equipment, appliance and component manufacturing",
 "Electrical lighting equipment manufacturing",
 "Household appliance manufacturing",
 "Electric equipment manufacturing",
 "Other electrical equipment and component manufacturing",
 "Transportation equipment manufacturing",
 "Motor vehicle manufacturing",
 "Motor vehicle body and trailer manufacturing",
 "Motor vehicle parts manufacturing",
 "Aerospace product and parts manufacturing",
 "Railroad rolling stock manufacturing",
 "Ship and boat building",
 "Other transportation equipment manufacturing",
 "Furniture and related product manufacturing",
 "Miscellaneous manufacturing",
 "Medical equipment and supplies manufacturing",
 "All surveyed industries except manufacturing",
 "Selected service industries",
 "Wholesale Trade",
 "Retail Trade",
 "Transportation and warehousing",
 "Air transportation",
 "Rail transportation",
 "Water transportation",
 "Truck transportation",
 "Transit and ground passenger transportation",
 "Pipeline transportation",
 "Scenic and sightseeing transportation",
 "Support activities for transportation",
 "Postal service and couriers and messengers",
 "Warehousing and storage",
 "Information and cultural industries",
 "Newspaper, periodical, book and directory publishers",
 "Software publishers",
 "Motion picture and video industries",
 "Wired telecommunications carriers",
 "Wireless telecommunications carriers (except satellite)",
 "Satellite telecommunications",
 "Software publishers",
 "internet publishing and broadcasting, and web search portals",
 "computer systems design and related services",
 "and data processing, hosting, and related services",
 "Data processing, hosting and related services",
 "Internet publishing and broadcasting, and web search portals",
 "Finance and insurance",
 "Credit intermediation and related activities and monetary authorities - Central Bank",
 "Securities, commodity contracts intermediation and brokerage",
 "Insurance carriers and related activities and funds and other financial vehicles",
 "Real estate and rental and leasing",
 "Professional, scientific, and technical services",
 "Professional, scientific, and technical services except scientific research and development services",
 "Architectural, engineering and related services",
 "Architectural services",
 "landscape architectural services",
 "engineering services",
 "drafting services",
 "building inspection services",
 "geophysical surveying and mapping services",
 "surveying and mapping (except geophysical) services",
 "industrial design services",
 "and environmental consulting services",
 "Testing laboratories",
 "Computer systems design and related services",
 "Management, scientific and technical consulting services",
 "Scientific research and development services",
 "Advertising, public relations and related services",
 "Management of companies and enterprises",
 "Administrative and support, waste management and remediation services",
 "Agriculture, forestry, fishing and hunting",
 "mining, quarrying, and oil and gas extraction",
 "utilities",
 "construction",
 "retail trade",
 "finance and insurance",
 "real estate and rental and leasing",
 "management of companies and enterprises",
 "and administrative and support, waste management and remediation services"]